import type { ExtensionHandler } from '@atlaskit/editor-common/extensions/extension-handler';

import type { InlineExternalImageParams } from '@confluence/inline-external-image/entry-points/InlineExternalImage.ts';

import type { InlineImageParams } from '../extensionHandlerTypes.ts';

type ExtensionParamsType = InlineExternalImageParams | InlineImageParams;

export const getTemplateMigrationExtHandler =
	(): ExtensionHandler<ExtensionParamsType> => (extension) => {
		if (!extension) {
			return null;
		}
		// Add template migration extension handlers logic here

		return null;
	};
